import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const DataClassification: React.FC = () => {
  const sections = [
    {
      title: 'Data Classification and Protection',
      content: 'Our data classification services help organizations identify, categorize, and protect their most valuable information assets. We implement comprehensive data classification frameworks that enable appropriate security controls and compliance with data protection regulations.',
      benefits: [
        'Comprehensive data discovery and inventory',
        'Automated data classification and labeling',
        'Data sensitivity and criticality assessment',
        'Protection policy development and implementation',
        'Data lifecycle management and retention policies'
      ]
    },
    {
      title: 'Classification Framework',
      content: 'We develop customized data classification frameworks tailored to your organization\'s specific needs, industry requirements, and regulatory obligations.',
      benefits: [
        'Multi-level classification schema development',
        'Data handling and processing guidelines',
        'Access control and permission frameworks',
        'Data sharing and transfer protocols',
        'Incident response procedures for classified data'
      ]
    },
    {
      title: 'Implementation and Governance',
      content: 'Our experts guide you through the complete implementation process, ensuring sustainable data governance and continuous improvement.',
      benefits: [
        'Data governance committee establishment',
        'Staff training and awareness programs',
        'Automated classification tool deployment',
        'Monitoring and compliance reporting',
        'Regular review and framework updates'
      ]
    }
  ];

  const sidebarInfo = [
    {
      title: 'Implementation Timeline',
      content: 'Data classification projects typically take 3-6 months for full implementation across the organization.'
    },
    {
      title: 'Compliance Support',
      content: 'Our frameworks support GDPR, HIPAA, PCI DSS, and other regulatory data protection requirements.'
    },
    {
      title: 'Technology Integration',
      content: 'We integrate with leading DLP, CASB, and data governance platforms for automated classification.'
    }
  ];

  return (
    <ServiceTemplate
      title="Data Classification"
      subtitle="Comprehensive data classification services to identify, categorize, and protect your organization's critical information assets."
      sections={sections}
      ctaTitle="Secure Your Data Assets"
      ctaDescription="Implement a robust data classification framework to protect sensitive information and ensure regulatory compliance."
      sidebarInfo={sidebarInfo}
    />
  );
};

export default DataClassification;

